import { AuthLayout } from '../../components/layout/AuthLayout'
import { DashboardPreview } from '../../components/layout/DashboardPreview'
import { ResetPasswordForm } from '../../components/forms/ResetPasswordForm'

export const ResetPasswordPage = () => {
  return (
    <AuthLayout preview={<DashboardPreview />}>
      <ResetPasswordForm />
    </AuthLayout>
  )
}
